export interface ListFilters {
  search?: string;
  rarity?: string;
  nametag?: string;
  animeId?: number;
  characterId?: number;
  favorites?: boolean;
  friendId?: string;
  rank?: string;
  filter?: string;
}

export function hasListIntent(filters: ListFilters): boolean {
  return Boolean(
    filters.search?.trim() || filters.rarity || filters.nametag?.trim() ||
    filters.animeId || filters.characterId || filters.favorites || filters.friendId ||
    filters.rank || (filters.filter && filters.filter !== 'all'),
  );
}
